import { createStyles } from '@mantine/core'

export default createStyles((theme) => {
  return {
    nav: {
      position: 'relative',
      borderBottom: `1px solid ${theme.colors.neutral[1]}`,
      gap: 16,
      [theme.fn.largerThan('sm')]: {
        gap: 24,
      },
    },
    navItem: {
      padding: '16px 0 10px',
      borderBottom: '2px solid transparent',
      whiteSpace: 'nowrap',
      cursor: 'pointer',
      '&.selected': {
        borderBottomColor: theme.fn.primaryColor(),
        color: theme.fn.primaryColor(),
      },
      // [theme.fn.smallerThan('sm')]: {
      //   '&:last-child': {
      //     paddingRight: '16px',
      //   },
      // },
    },
  }
})
